var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c(
        "div",
        { staticClass: "title-container is-flex is-centered payments" },
        [
          _c(
            "h2",
            {
              staticClass: "title is-4 has-text-primary title-invoice-payments"
            },
            [_vm._v("\n      Pagos\n    ")]
          ),
          _vm.paymentsExpired
            ? _c("span", { staticClass: "tag is-danger" }, [
                _vm._v("\n      Los pagos expiraron\n    ")
              ])
            : _c("span", { staticClass: "tag is-success" }, [
                _vm._v("\n      Los pagos aún estan vigentes\n    ")
              ])
        ]
      ),
      _c(
        "b-table",
        {
          attrs: { data: _vm.payments, "mobile-cards": "" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(props) {
                return [
                  _c(
                    "b-table-column",
                    { attrs: { field: "amount", label: "Monto" } },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm._f("toCurrency")(
                              props.row.amount,
                              props.row.currency
                            )
                          ) +
                          "\n      "
                      )
                    ]
                  ),
                  _c(
                    "b-table-column",
                    { attrs: { field: "currency", label: "Fecha y hora" } },
                    [
                      _vm._v(
                        "\n        " + _vm._s(props.row.currency) + "\n      "
                      )
                    ]
                  ),
                  _c(
                    "b-table-column",
                    { attrs: { field: "date", label: "Fecha", centered: "" } },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm._f("toHumanDate")(props.row.datetime)) +
                          "\n      "
                      )
                    ]
                  )
                ]
              }
            }
          ])
        },
        [
          _c("template", { slot: "empty" }, [
            _c("section", { staticClass: "section" }, [
              _c(
                "div",
                { staticClass: "content has-text-grey has-text-centered" },
                [
                  _c(
                    "p",
                    [
                      _c("b-icon", {
                        attrs: { icon: "emoticon-sad", size: "is-large" }
                      })
                    ],
                    1
                  ),
                  _c("p", [_vm._v("Aún no hay pagos a esta factura")])
                ]
              )
            ])
          ])
        ],
        2
      ),
      _c("h2", { staticClass: "title is-4 has-text-primary pending-balance" }, [
        _vm._v("\n    Monto pendiente\n  ")
      ]),
      _vm._l(_vm.paymentsCurrencies, function(currency) {
        return _c(
          "div",
          { key: currency, staticClass: "pending-balance-amount" },
          [
            _vm._v(
              "\n    " +
                _vm._s(_vm._f("toCurrency")(_vm.debt, currency)) +
                "\n  "
            )
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }